import React from "react"
import Text from "./Text"

const Email = () => (
  <Text field="email" label="Email" placeholder="johndoe@example.com" />
)

export default Email
